module.exports = __webpack_public_path__ + "static/media/marker-img-grey.ddc68198.svg";